module.exports = __webpack_public_path__ + "img/imgHeader_02.cb618248.png";